var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.417V5.66699C16.6667 4.26686 16.6667 3.5668 16.3942 3.03202C16.1545 2.56161 15.7721 2.17916 15.3017 1.93948C14.7669 1.66699 14.0668 1.66699 12.6667 1.66699H7.33334C5.93321 1.66699 5.23315 1.66699 4.69837 1.93948C4.22796 2.17916 3.84551 2.56161 3.60583 3.03202C3.33334 3.5668 3.33334 4.26686 3.33334 5.66699V14.3337C3.33334 15.7338 3.33334 16.4339 3.60583 16.9686C3.84551 17.439 4.22796 17.8215 4.69837 18.0612C5.23315 18.3337 5.93321 18.3337 7.33334 18.3337H10M11.6667 9.16699H6.66668M8.33334 12.5003H6.66668M13.3333 5.83366H6.66668M12.0833 15.8337L13.75 17.5003L17.5 13.7503",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceInactive);
export default __webpack_public_path__ + "static/media/ComplianceInactive.a30cf25013e744520b9a115d6b346753.svg";
export { ForwardRef as ReactComponent };